import { useMediaQuery } from 'react-responsive';
import { useLocation, useNavigate } from 'react-router-dom';

import Button from '@/components/ui/buttons/Button';

import styles from './AnnouncementDetailFooter.module.scss';

export interface LocationState {
  from?: 'list';
}

const AnnouncementDetailFooter: React.FC = () => {
  const isMobile = useMediaQuery({ query: '(max-width: 639px)' });
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state as LocationState;

  const handleOnclickBack = (e: React.MouseEvent) => {
    e.preventDefault();

    if (state?.from === 'list') {
      navigate(-1);
    } else {
      navigate('/announcements');
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        <Button
          color="link"
          size={isMobile ? 'm' : 'l'}
          onClick={handleOnclickBack}
          className={styles.button}
        >
          &lt; 戻る
        </Button>
      </div>
    </div>
  );
};

export default AnnouncementDetailFooter;
